import styled from 'styled-components';
import React from 'react';
import Pic from '../assets/images/anonymous.png'

const YourAnonymity = () => {
    return (
        <Text>
            Your <Highlight>responses</Highlight> are anonymous
            and will never be
            attached to <Image src={Pic} alt="Image description" /> <Bold>your identity.</Bold>
        </Text>
    )
}

export default YourAnonymity

const Text = styled.div`
font-weight: 500;
font-size: 44px;
line-height: 1.4;
color: #2A3039;

@media (max-width: 768px) {
    font-size: 38px;
}
`

const Image = styled.img`
    height:52px;
    display: inline;
    vertical-align: middle;
    margin-left: 5px;
    margin-right: 5px;
    border-radius: 30px;
`

const InlineWrapper = styled.span`
  display: inline-flex;
  align-items: center;
`;

const Highlight = styled.span`
background: #EBF1FD;
border-radius: 40px;
padding:0px 16px;
margin:0px 0px 0px -8px;

`

const Bold = styled.span`
    font-weight:600;
    color:#2D70E2;
`
